// CSS
import './main.scss';

// Global custom elements
import '../global/custom-elements/modal-dialog';
import '../global/custom-elements/modal-opener';
import '../global/custom-elements/deferred-media';
import '../global/custom-elements/footer-accordions';
import '../global/custom-elements/testimonials';
import '../global/custom-elements/text-icon-carousel';
